// N1 → N11 lifecycle matching the CHK project cycle
export type OpportunityStatus =
  | '1. Levantamento Inicial'
  | '2. Levantamento de Necessidades'
  | '3. Especificação Técnica'
  | '4. Proposta em Elaboração'
  | '5. Proposta Enviada'
  | '6. Decisão do Cliente'
  | '7. Ordem de Trabalho Gerada'
  | '8. Em Execução'
  | '9. Entrega & Validação'
  | '10. Concluído / Ganho'
  | '11. Perdido / Cancelado';

export type TechnicalStatus =
  | 'Não Iniciado'
  | 'Em Levantamento'
  | 'Em Especificação Técnica'
  | 'Aguardando Info Comercial/Cliente'
  | 'Parecer Técnico Concluído'
  | 'Em Execução'
  | 'Execução Concluída';

export const LANE: Record<OpportunityStatus, 'Comercial' | 'Técnico' | 'Cliente'> = {
  '1. Levantamento Inicial':          'Comercial',
  '2. Levantamento de Necessidades':  'Técnico',
  '3. Especificação Técnica':         'Técnico',
  '4. Proposta em Elaboração':        'Comercial',
  '5. Proposta Enviada':              'Comercial',
  '6. Decisão do Cliente':            'Cliente',
  '7. Ordem de Trabalho Gerada':      'Comercial',
  '8. Em Execução':                   'Técnico',
  '9. Entrega & Validação':           'Técnico',
  '10. Concluído / Ganho':            'Comercial',
  '11. Perdido / Cancelado':          'Comercial',
};

export const STATUS_SEQUENCE: OpportunityStatus[] = [
  '1. Levantamento Inicial',
  '2. Levantamento de Necessidades',
  '3. Especificação Técnica',
  '4. Proposta em Elaboração',
  '5. Proposta Enviada',
  '6. Decisão do Cliente',
  '7. Ordem de Trabalho Gerada',
  '8. Em Execução',
  '9. Entrega & Validação',
  '10. Concluído / Ganho',
];

export const NEXT_STATUS: Partial<Record<OpportunityStatus, OpportunityStatus>> = {
  '1. Levantamento Inicial':          '2. Levantamento de Necessidades',
  '2. Levantamento de Necessidades':  '3. Especificação Técnica',
  '3. Especificação Técnica':         '4. Proposta em Elaboração',
  '4. Proposta em Elaboração':        '5. Proposta Enviada',
  '5. Proposta Enviada':              '6. Decisão do Cliente',
  '6. Decisão do Cliente':            '7. Ordem de Trabalho Gerada',
  '7. Ordem de Trabalho Gerada':      '8. Em Execução',
  '8. Em Execução':                   '9. Entrega & Validação',
  '9. Entrega & Validação':           '10. Concluído / Ganho',
};

export const STATUS_COLOR: Record<OpportunityStatus, string> = {
  '1. Levantamento Inicial':          '#8892AA',
  '2. Levantamento de Necessidades':  '#60A5FA',
  '3. Especificação Técnica':         '#A78BFA',
  '4. Proposta em Elaboração':        '#F59E0B',
  '5. Proposta Enviada':              '#FB923C',
  '6. Decisão do Cliente':            '#E879F9',
  '7. Ordem de Trabalho Gerada':      '#34D399',
  '8. Em Execução':                   '#1755B8',
  '9. Entrega & Validação':           '#06B6D4',
  '10. Concluído / Ganho':            '#22C55E',
  '11. Perdido / Cancelado':          '#EF4444',
};

export const LANE_COLOR: Record<string, string> = {
  Comercial: '#CC2936',
  Técnico:   '#1755B8',
  Cliente:   '#E879F9',
};

// Phases that require a confirmation dialog before advancing (irreversible or high-impact)
export const CONFIRM_REQUIRED = new Set<string>([
  '6. Decisão do Cliente',
  '10. Concluído / Ganho',
  '11. Perdido / Cancelado',
]);

export interface OpportunityItem {
  id: string;
  codigoOportunidade: string;
  cliente: string;
  contactoCliente?: string;
  comercialEmail: string;
  comercialNome: string;
  statusOportunidade: OpportunityStatus;
  ambitoNecessidades: string;
  responsavelTecnicoEmail?: string;
  responsavelTecnicoNome?: string;
  statusTecnico: TechnicalStatus;
  parecerTecnico?: string;
  historicoParecer?: string;
  dataLimiteParecer?: string;
  dataAceitacao?: string;
  numeroOT?: string;
  progressoExecucao?: number;
  diarioBordo?: string;
  termoAceite?: string;
  motivoPerda?: string;
  // Financial
  valorEstimado?: number;
  // Timestamps for audit
  dataUltimaActualizacao?: string;
  faseHistorico?: string; // JSON string of {fase, data, autor}[]
}

export interface UpdateTechnicalReviewPayload {
  statusTecnico: TechnicalStatus;
  parecerTecnico: string;
  novoStatusOportunidade?: OpportunityStatus;
}
